/**
 * @generated SignedSource<<f085de8b4c80cd53bcf7cca4e47d399b>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type connectCatalogQuery$variables = Record<PropertyKey, never>;
export type connectCatalogQuery$data = {
  readonly generalSettings: {
    readonly isSideImageScalingEnabled: boolean;
  };
};
export type connectCatalogQuery = {
  response: connectCatalogQuery$data;
  variables: connectCatalogQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSideImageScalingEnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "connectCatalogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralSettings",
        "kind": "LinkedField",
        "name": "generalSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "connectCatalogQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GeneralSettings",
        "kind": "LinkedField",
        "name": "generalSettings",
        "plural": false,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "043c5796d19f1e9fd6d3816c902494dc",
    "id": null,
    "metadata": {},
    "name": "connectCatalogQuery",
    "operationKind": "query",
    "text": "query connectCatalogQuery {\n  generalSettings {\n    isSideImageScalingEnabled\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "78972f0fa676be7564d5908015f03bd2";

export default node;
